import React from "react";
import { Skeleton } from "@mui/material";

const ChatMessagesSkeleton = ({ heightMapping }: { heightMapping: string }) => {
  return (
    <>
      <div
        className="tw-px-8 tw-py-4 tw-space-y-6 tw-overflow-auto"
        style={{
          height: heightMapping,
        }}
      >
        {[1, 2, 3, 4].map((index) => (
          <div
            key={index}
            className={`tw-space-y-2 ${
              index % 2 === 0 ? "tw-flex tw-items-end tw-flex-col" : ""
            }`}
          >
            {/* Message Header */}
            <div className="tw-flex tw-items-center tw-space-x-2">
              {index % 2 !== 0 && (
                <>
                  <Skeleton
                    variant="circular"
                    width={32}
                    height={32}
                    className="tw-bg-gray-200"
                  />
                  <Skeleton
                    variant="text"
                    width={100}
                    height={24}
                    className="tw-bg-gray-200"
                  />
                </>
              )}
              <Skeleton
                variant="text"
                width={80}
                height={20}
                className="tw-bg-gray-200"
              />
            </div>

            {/* Message Content */}
            <div
              className={`${
                index % 2 === 0 ? "" : "tw-ml-10"
              } tw-max-w-[558px]`}
            >
              <Skeleton
                variant="rectangular"
                width="100%"
                height={80}
                className="tw-rounded-lg tw-bg-gray-200"
              />
            </div>
          </div>
        ))}
      </div>

      {/* Input Area Skeleton */}
      <div className="tw-px-8 tw-py-4">
        <div className="tw-relative tw-flex tw-items-center">
          <Skeleton
            variant="rectangular"
            width="100%"
            height={48}
            className="tw-rounded-lg tw-bg-gray-200"
          />
          <div className="tw-absolute tw-right-2">
            <Skeleton
              variant="circular"
              width={32}
              height={32}
              className="tw-bg-gray-200"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatMessagesSkeleton;
